import { CallActivityPerformanceProps, IWashoutModel } from "@/Washouts/types/commons";
import CallActivityPerformance from "../tables/Common/CallActivityPerformance";
import { GridValidRowModel } from "@mui/x-data-grid-premium";
import { nullishResolver } from "@/Common/helpers/sonar";

export function getCallActivityData(model?: IWashoutModel): GridValidRowModel[] {
	const averageTurnAroundTime = model?.callActivityPerformance?.averageTurnAroundTime?.individual;
	return [
		{
			_id: "1",
			callType: "Inbound Calls",
			queue: nullishResolver(model?.callActivityPerformance?.inboundCalls.queue, 0),
			individual: nullishResolver(model?.callActivityPerformance?.inboundCalls.individual, 0),
			total: nullishResolver(model?.callActivityPerformance?.inboundCalls.total, 0),
		},
		{
			_id: "2",
			callType: "Inbound Mishandled Calls",
			queue: nullishResolver(model?.callActivityPerformance?.inboundMishandledCalls.queue, 0),
			individual: nullishResolver(model?.callActivityPerformance?.inboundMishandledCalls.individual, 0),
			total: nullishResolver(model?.callActivityPerformance?.inboundMishandledCalls.total, 0),
		},
		{
			_id: "3",
			callType: "Outbound Calls",
			queue: nullishResolver(model?.callActivityPerformance?.outboundCalls.queue, 0),
			individual: nullishResolver(model?.callActivityPerformance?.outboundCalls.individual, 0),
			total: nullishResolver(model?.callActivityPerformance?.outboundCalls.total, 0),
		},
		{
			_id: "4",
			callType: "Outbound to Mishandled Calls",
			queue: nullishResolver(model?.callActivityPerformance?.outboundMishandledCalls.queue, 0),
			individual: nullishResolver(model?.callActivityPerformance?.outboundMishandledCalls.individual, 0),
			total: nullishResolver(model?.callActivityPerformance?.outboundMishandledCalls.total, 0),
			turnAroundTime: averageTurnAroundTime,
		},
		{
			_id: "5",
			callType: "Successfully Returned Mishandled Calls",
			queue: nullishResolver(model?.callActivityPerformance?.successfullyReturnedMishandledCalls.queue, 0),
			individual: nullishResolver(model?.callActivityPerformance?.successfullyReturnedMishandledCalls.individual, 0),
			total: nullishResolver(model?.callActivityPerformance?.successfullyReturnedMishandledCalls.total, 0),
		},
	];
}

export default function CallActivityPerformanceWrapper(
	props: Readonly<CallActivityPerformanceProps> & {
		model?: IWashoutModel;
	}
) {
	const { model } = props;
	if (props.dataPresent) {
		return (
			<CallActivityPerformance
				{...props}
				addTooltip
				title={"Call Activity Performance"}
				data={getCallActivityData(model)}
				percents={{
					_id: "footer",
					callType: "Unattended Mishandled Calls (%)",
					queue: model?.callActivityPerformance?.unattendedMishandledCallsPercent.queue,
					individual: model?.callActivityPerformance?.unattendedMishandledCallsPercent.individual,
					total: model?.callActivityPerformance?.unattendedMishandledCallsPercent.total,
				}}
			/>
		);
	}
	return null;
}
